import { useContext, useEffect, useState } from "react";
import { Row, Col, Spin, Empty, Segmented, Space } from "antd";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";
import { useClient } from "hooks/useClient";
import DistributionPointSelected from "context/MyDistributionPoint";
import { getAllDispensaries, type ResponseGetDispensary } from "api/generated";
import { DispensaryCard } from "./components/DispensaryCard";

export default function DispensariesScreen() {
  const { client } = useClient();
  const { distributionPoint } = useContext(DistributionPointSelected);
  const [dispensaries, setDispensaries] = useState<ResponseGetDispensary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");

  useEffect(() => {
    if (!distributionPoint?.id) return;

    const fetchDispensaries = async () => {
      setIsLoading(true);
      try {
        const response = await getAllDispensaries({
          client,
          path: {
            distributionPointId: distributionPoint.id,
          },
        });
        setDispensaries(response.data ?? []);
      } catch (error) {
        console.error("Error al obtener dispensarios:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDispensaries();
  }, [distributionPoint, client]);

  if (!distributionPoint) {
    return <Empty description="Selecciona un punto de distribución" />;
  }

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Dispensarios: {distributionPoint.name}</h2>
        <Segmented
          value={viewMode}
          onChange={(value) => setViewMode(value as "grid" | "list")}
          options={[
            { value: "grid", icon: <AppstoreOutlined /> },
            { value: "list", icon: <BarsOutlined /> },
          ]}
        />
      </div>

      {isLoading ? (
        <div style={{ textAlign: "center", padding: 48 }}>
          <Spin size="large" />
        </div>
      ) : dispensaries.length === 0 ? (
        <Empty description="No hay dispensarios registrados" />
      ) : viewMode === "grid" ? (
        <Row gutter={[16, 16]}>
          {dispensaries.map((dispensary) => (
            <Col key={dispensary.idEquipment} xs={24} sm={12} lg={8} xl={6}>
              <DispensaryCard
                id={dispensary.idEquipment ?? ""}
                codigo={dispensary.dispensaryCode ?? "-"}
                serialNumber={dispensary.serialNumber}
                estado={dispensary.status ?? "DESCONOCIDO"}
                ultimaComunicacion={dispensary.lastCommunicationDate}
                viewMode="grid"
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          {dispensaries.map((dispensary) => (
            <DispensaryCard
              key={dispensary.idEquipment}
              id={dispensary.idEquipment ?? ""}
              codigo={dispensary.dispensaryCode ?? "-"}
              serialNumber={dispensary.serialNumber}
              estado={dispensary.status ?? "DESCONOCIDO"}
              ultimaComunicacion={dispensary.lastCommunicationDate}
              viewMode="list"
            />
          ))}
        </Space>
      )}
    </div>
  );
}
